import { createSelector } from 'reselect'
import { PostOrderFeedbackState } from './types'

export const selectPostOrderFeedbackState = (state: {
  postOrderFeedback: PostOrderFeedbackState
}) => state.postOrderFeedback

// `selectFormDisabled` projects `isFormSubmitting`: the only reason the form
// should be disabled today is "a save is in flight." Keeping a separate
// `isFormDisabled` field that nothing dispatches would be dead state and a
// future maintenance footgun. When a real second reason to disable arrives
// (e.g. a merchant-level capability that gates the toggle), reintroduce a
// semantically-named field at that point rather than reviving the dead one.
export const selectFormDisabled = createSelector(
  [selectPostOrderFeedbackState],
  postOrderFeedbackState => postOrderFeedbackState.isFormSubmitting
)

export const selectAllowPostOrderFeedbackEmail = createSelector(
  [selectPostOrderFeedbackState],
  postOrderFeedbackState => postOrderFeedbackState.allowPostOrderFeedbackEmail
)

export const selectIsFormSubmitting = createSelector(
  [selectPostOrderFeedbackState],
  postOrderFeedbackState => postOrderFeedbackState.isFormSubmitting
)

export const selectApiFormattedFormData = createSelector(
  [selectPostOrderFeedbackState],
  postOrderFeedbackState => ({
    allow_post_order_feedback_email:
      postOrderFeedbackState.allowPostOrderFeedbackEmail,
  })
)
